import React, {Component} from 'react'
import { render } from 'react-dom'
import { translation } from '../../../utils/helpers'

import { Provider } from 'react-redux'
import store from '../../../store'

class Portal extends Component {

  constructor (props) {
    super(props)
    this.portalElement = null
  }

  render () {
    return null
  }

  componentDidMount () {
    let p = this.props.portalId && document.getElementById(this.props.portalId)
    if (!p) {
      p = document.createElement('div')
      p.id = this.props.portalId
      document.body.appendChild(p)
    }
    this.portalElement = p
    this.componentDidUpdate()
  }

  componentWillUnmount () {
    this.props.onPortalClose()
    document.body.removeChild(this.portalElement)
  }

  componentDidUpdate () {
    const renderChild = () => {
      if (this.props.dontSendT) return React.cloneElement(this.props.children)
      return React.cloneElement(this.props.children, {t: translation || this.props.t})
    }
    render(
      <Provider store={store}>
        <div className={this.props.className}>
          {renderChild()}
        </div>
      </Provider>,
      this.portalElement
    )
  }

}

export default Portal



// WEBPACK FOOTER //
// ./src/app/shared/components/Portal/index.js